require('./cardsCancelPayLaterConfirmationStep.scss');

// @vendors
const PropTypes = require('prop-types');
const React = require('react');

// @commons
const PreLeaveModalComponent = require('components/preLeaveModalComponent/preLeaveModalComponent');

// @components
const { SignaturePattern } = require('components/signaturePattern/signaturePattern');

// @helpers
const { FormattedText } = require('core/i18n').i18n;

// @constants
const { CARD_CANCEL_PAY_LATER_ID } = require('constants/operationTypes');
const CLASS_NAME = 'cards-cancel-pay-later-confirmation-step';

class CardsCancelPayLaterConfirmationStep extends React.Component {

    constructor(props) {
        super(props);
        this.isReady = this.isReady.bind(this);
    }

    isReady() {
        return false;
    }

    render() {

        const { informativeList, reset, immCard } = this.props;
        const originAccount = immCard.get('fullContractNumber').replace(/\s/g, '');
        const operationParams = {
            originAccount
        }
        const confirmationMessage = (<FormattedText value="cardCancelPayLater-cardCancelPayLater_redirectConfirmationMessage" />);
        const confirmationTitle = (<FormattedText value="cardCancelPayLater-cardCancelPayLater_redirectConfirmationTitle" />);
        const acceptText = (<FormattedText value="cardCancelPayLater-cardCancelPayLater_redirectConfirmationAcceptButton" />);
        const cancelText = (<FormattedText value="cardCancelPayLater-cardCancelPayLater_redirectConfirmationCancelButton" />);

        return (
            <div className={`${CLASS_NAME}`}>
                <div className={`${CLASS_NAME}__title`}>
                    <FormattedText value="cardCancelPayLater-cardCancelPayLater_confirmationTitle" />
                </div>
                <div className={`${CLASS_NAME}__subtitle`}>
                    <FormattedText value="cardsCancelPayLater-cardsCancelPayLater_confirmationSubtitle" />
                </div>
                <div className={`${CLASS_NAME}__content`}>
                    {informativeList}
                </div>
                <div className={`${CLASS_NAME}__signature-pattern`}>
                    <SignaturePattern
                        operationType={CARD_CANCEL_PAY_LATER_ID}
                        operationParams={operationParams}
                    />
                </div>
                <PreLeaveModalComponent
                    acceptText={acceptText}
                    cancelText={cancelText}
                    confirmationMessage={confirmationMessage}
                    confirmationTitle={confirmationTitle}
                    onConfirmLeave={reset}
                    isReady={this.isReady}
                />
            </div>
        );
    }
}

CardsCancelPayLaterConfirmationStep.propTypes = {
    immCard: PropTypes.object.isRequired,
    informativeList: PropTypes.any,
    reset: PropTypes.func.isRequired,
};

module.exports = CardsCancelPayLaterConfirmationStep;